import Vue from 'vue';

import ConfirmModal from '@/components/confirm-modal.vue';
import AlertModal from '@/components/alert-modal.vue';

export interface ConfirmModalOptions {
    title?: string;
    body?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmClass?: string;
    cancelClass?: string;
}


export interface AlertModalOptions {
    title?: string;
    body?: string;
    confirmLabel?: string;
    confirmClass?: string;
}

// https://stackoverflow.com/questions/52960721/promise-based-dialogue-vue-js
export function confirm(options?: ConfirmModalOptions) {
    return new Promise((resolve, reject) => {
        const dialog = new Vue<any>({
            methods: {
                closeHandler(fn: Function, arg: any) {
                    return function () {
                        fn(arg);
                        dialog.$destroy();
                        dialog.$el.remove();
                    };
                }
            },
            render(createElement) {
                return createElement(ConfirmModal, {
                    props: {
                        cancelClass: 'red',
                        ...options
                    },
                    on: {
                        confirm: this.closeHandler(resolve, true),
                        cancel: this.closeHandler(resolve, false)
                    }
                });
            }
        }).$mount();
        document.body.appendChild(dialog.$el);
    });
}

export function alert(options?: AlertModalOptions | string) {
    return new Promise((resolve, reject) => {
        const dialog = new Vue<any>({
            methods: {
                closeHandler(fn: Function, arg: any) {
                    return function () {
                        fn(arg);
                        dialog.$destroy();
                        dialog.$el.remove();
                    };
                }
            },
            render(createElement) {
                const props = typeof options === 'string' ?
                    {
                        body: options
                    } : {
                        ...options
                    };
                return createElement(AlertModal, {
                    props,
                    on: {
                        ok: this.closeHandler(resolve, true)
                    }
                });
            }
        }).$mount();
        document.body.appendChild(dialog.$el);
    });
}